import { USER_PLAN } from '@/constant/storage';
import useToggle from '@/hooks/useToggle';
import useUserPlan from '@/hooks/useUserPlan';
import { Button, ButtonProps } from 'design-system/components/Button';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { useFetchCourseDetails } from '../../../../hooks/course/useFetchCourseDetails';
import { EOrderStatus } from '../../../../interfaces/training.interface';
import { QuickLoginModalHOC } from '../../../modal/LoginModal2HOC';
import PurchaseForCourseOnly from '../../purchase/PurchaseForCourseOnly';

const renderContentPurchase = (status: EOrderStatus) => {
  return status === EOrderStatus.Pending
    ? 'Tiếp tục thanh toán'.normalize()
    : 'Mua ngay'.normalize();
};

const DynamicModalVerifyAccount = dynamic(
  () => import('../ModalVerifyAccount')
);

const PurchaseButton = ({
  isGreen = false,
  isRequiresVerified,
  buttonProps,
}: {
  isGreen?: boolean;
  isRequiresVerified: boolean;
  buttonProps?: ButtonProps;
}) => {
  const { queryReturn } = useFetchCourseDetails();
  const order = queryReturn.data?.userOrder;
  const userPlan = useUserPlan();

  const [openBill, setOpenBill] = useState(false);
  const [openModalVerify, toggleModalVerify] = useToggle();

  const toggle = () => setOpenBill((p) => !p);
  const handleClickPurchase = () => {
    const needVerifiedAccount =
      (userPlan === USER_PLAN.Education || userPlan === USER_PLAN.Personal) &&
      isRequiresVerified;
    if (needVerifiedAccount) {
      toggleModalVerify();
      return;
    }

    toggle();
  };

  return (
    <>
      <QuickLoginModalHOC
        handleClickWhenDisabledQuickLogin={handleClickPurchase}
        loginSuccessCb={() => window.location.reload()}
      >
        <Button
          emphasis="high"
          className="w-full"
          startIcon={{
            name: 'buy',
          }}
          {...buttonProps}
        >
          {renderContentPurchase(order ? order?.status : EOrderStatus.Failed)}
        </Button>
      </QuickLoginModalHOC>

      {openBill && <PurchaseForCourseOnly open={openBill} toggle={toggle} />}
      {openModalVerify && (
        <DynamicModalVerifyAccount
          open={openModalVerify}
          onClose={toggleModalVerify}
        />
      )}
    </>
  );
};

export default PurchaseButton;
